export const MergeContactLogPermissions = {
  GetMergeContactLog: {
    permissionsId: '47b2d3a3-d657-48b9-2dc3-08db2efccb76',
    permissionsName: 'GetMergeContactLog',
    description: null,
    componentsId: null,
    components: null
  }
};
